// PersonCard.js

import React from 'react';
import PropTypes from 'prop-types';
import './PersonCard.css';

const PersonCard = ({ name, imagePath }) => {
  return (
    <div className="brotherCard">
      <img src={imagePath} alt={`${name} Image`} />
      <p className="brotherCard">{name}</p>
    </div>
  );
};

PersonCard.propTypes = {
  name: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
};

export default PersonCard;